const COLOR = {
    AREA_CHART: "#0650ff",
    BAR_CHART: "#82ca9d",
    FILTER_BUTTON: "orange.600",
    BLUE_BUTTON: "blue.600",
    BLUE_BUTTON_TEXT: 'white',
}

export default COLOR;